import React from 'react'
import { useContext } from '../Context'
import { PopUpContainer } from '../../../../components/header/quick-create/PopUpContainer'
import { MenuPopUpEnum } from '../../../../components/header/quick-create/MenuPopUpEnum'
import { AddNewProductForm } from '../../../../components/AddProduct/AddNewProductForm'

export const ProductPopUp = () => {
  const { menuTarget, onSuccessSubmit } = useContext()

  return (
    <PopUpContainer show={menuTarget?.show === MenuPopUpEnum.product} target={menuTarget?.target}>
      <AddNewProductForm onSuccessSubmit={onSuccessSubmit} />
    </PopUpContainer>
  )
}
